<div *ngIf="!isEdited" class="cell-view align-end">
  <span class="inner-view-currency">{{ repr }}</span>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="CurrencyCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && hasValue()"
      id="cancelRowSelection"
      data-cy="CurrencyCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup inline-edit-wrapper-currency">
    <jml-lib-currency-control
      #currencyInput="ngModel"
      [ngModel]="rowData[fieldName]?.currency"
      (ngModelChange)="setValue($event)"
      (click)="$event.stopPropagation()"
      (keyup.esc)="abortCellEdit($event)"
      (keyup.enter)="onKeyupEnter(currencyInput.valid)"
      (blur)="abortCellEdit($event)"
      jmlAutoFocus
    ></jml-lib-currency-control>
    <button
      pButton
      type="button"
      [id]="fieldName + '§' + rowData['id']"
      icon="pi pi-check"
      [disabled]="currencyInput.invalid"
    ></button>
  </div>
</ng-template>
